<template>
  <div class="tw-mt-5 tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-6 tw-gap-1">
            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">NOUVEAU CLIENTS</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        +25
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="la:user-alt" />
            </div>

            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">C.A DU JOUR</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        602 MAD
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="bx:rocket" />
            </div>

            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">R.BRUT DU JOUR</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        400 MAD
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="solar:calculator-broken" />
            </div>

            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">C.A REALISE</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        1,5013 MAD
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="streamline:money-cash-bag-dollar-bag-payment-cash-money-finance" />
            </div>

            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">R.BRUT REALISE</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        0 MAD
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="tabler:brand-cashapp" />
            </div>

            <div class="tw-p-3 tw-border tw-flex tw-justify-between">
                <div class="tw-flex tw-text-gray-600 tw-flex-col">
                    <span class="tw-text-xs tw-font-bold">N° DE VENTES</span>
                    <h1 class="tw-text-lg tw-font-medium tw-text-primary-500">
                        0
                    </h1>
                </div>
                <icon class="tw-text-4xl tw-text-gray-600" icon="ep:sell" />
            </div>
        </div>
</template>

<script>
export default {

}
</script>

<style>

</style>